import type { ReactNode } from 'react';
import { Sidebar } from './Sidebar';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="grid grid-cols-[360px_1fr] gap-4 p-4 h-full max-lg:grid-cols-1">
      <Sidebar />
      <div className="bg-gradient-to-b from-white/[.02] to-transparent border border-border rounded-[18px] shadow-lg overflow-auto p-4 min-h-[320px]">
        {children}
      </div>
    </div>
  );
}
